import { render, staticRenderFns } from "./HtmlBlock.vue?vue&type=template&id=86a46c2e&scoped=true&"
import script from "./HtmlBlock.vue?vue&type=script&lang=js&"
export * from "./HtmlBlock.vue?vue&type=script&lang=js&"
import style0 from "./HtmlBlock.vue?vue&type=style&index=0&id=86a46c2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a46c2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
